var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutorizar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.63354 15.0784L13.2461 18.6909L19.9999 11.937L18.534 10.4711L13.2461 15.759L11.0995 13.6124L9.63354 15.0784Z",
    fill: "#206021"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0791 2.82715V8.57617C15.0791 8.74095 15.0742 8.90466 15.0674 9.06738L13.3467 10.7891L13.0068 10.4492C13.1297 9.84455 13.1933 9.22057 13.1934 8.57617V4.12305L7.53906 2.00293L1.88477 4.12305V8.57617C1.88483 10.4156 2.38614 12.0927 3.38672 13.6084L3.33691 13.6592L3.61133 13.9336C4.19097 14.7398 4.85018 15.3993 5.58984 15.9121L8.29883 18.6211C8.05083 18.706 7.79775 18.7825 7.53906 18.8477C5.35603 18.2979 3.55417 17.0452 2.13281 15.0898C0.711439 13.1345 6.81066e-05 10.9634 0 8.57617V2.82715L7.53906 0L15.0791 2.82715ZM12.71 15.4023C12.3542 15.8593 11.9751 16.2736 11.5742 16.6475L10.2412 15.3145C10.6462 14.9491 11.0233 14.5328 11.3721 14.0645L12.71 15.4023Z",
    fill: "#206021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutorizar);
export default __webpack_public_path__ + "static/media/autorizar.ff65e7ec2a38b92b1fa891f29b5aeeba.svg";
export { ForwardRef as ReactComponent };